//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React from 'react';

import I18n   from 'i18next';

import PropTypes       from '@components/PropTypes';
import ComponentHelper from '@helper/ComponentHelper';

import styles from './styles.module.scss';

export default class UserInfoRow extends React.Component {
    static propTypes = {
        keyName: PropTypes.string,
        value:   PropTypes.string,
    };

    static defaultProps = {
        keyName: null,
        value:   null,
    };

    static renderAffectingProps = Object.keys(this.defaultProps);

    static renderAffectingStates = [];

    render() {
        const { keyName, value } = this.props;

        return (
            <div className={styles.row}>
                <span className={styles.key}>
                    {I18n.t(keyName)}
                </span>
                <span className={styles.value}>
                    {value}
                </span>
            </div>
        );
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ComponentHelper.shouldComponentUpdate(
            this,
            nextProps,
            nextState,
        );
    }
}
